import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/auth';
import 'firebase/firestore';
import Constants from "./Constants";

try{
    console.log(firebase.app());
} catch(e){
    firebase.initializeApp(Constants.CONFIG);
}

export default firebase;
